export const STOPS_RESET_STATE = 'STOPS_RESET_STATE';
export const STOPS_CURRENT_ITEM = 'STOPS_CURRENT_ITEM';

export const STOPS_REQUEST_LOADING = 'STOPS_REQUEST_LOADING';
export const STOPS_REQUEST_SUCCESS = 'STOPS_REQUEST_SUCCESS';
export const STOPS_REQUEST_FAILED = 'STOPS_REQUEST_FAILED';

export const STOPS_CURRENT_ACTION = 'STOPS_CURRENT_ACTION';
export const STOPS_RESET_ACTION = 'STOPS_RESET_ACTION';